module.exports = __webpack_public_path__ + "img/Splashes1.1727b602.jpg";